import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls:['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit, OnDestroy {
  @Input('formCtrl') formCtrl: FormControl;
  @Input('showSeconds') showSeconds: boolean
  date: NgbDateStruct = { year: 0, month: 0, day: 0 };
  time: NgbTimeStruct = {hour: 0, minute: 0, second: 0};
  showError = false;
  currentTZ: string;
  
  private valueChangesSubscription: Subscription;
  private statusChangesSubscription: Subscription;

  get currentTZVal() {
    if (this.formCtrl?.value) {
      return new Date(this.formCtrl.value);
    }
    return null;
  }
  
  constructor() {}
  
  ngOnInit(): void {
    if (this.formCtrl) {
      // 初始更新
      this.updateFromFormControl();
      
      // 监听值变化
      this.valueChangesSubscription = this.formCtrl.valueChanges.subscribe(value => {
        this.updateFromFormControl();
      });
      
      // 监听状态变化
      this.statusChangesSubscription = this.formCtrl.statusChanges.subscribe(status => {
        this.showError = status === 'INVALID';
      });
    }
  }

  ngOnDestroy() {
    // 清理所有订阅
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
    if (this.statusChangesSubscription) {
      this.statusChangesSubscription.unsubscribe();
    }
  }

  // 从表单控件值更新日期和时间
  updateFromFormControl() {
    if (this.formCtrl?.value) {
      const dateValue = new Date(this.formCtrl.value);
      
      // 确保日期有效
      if (!isNaN(dateValue.getTime())) {
        this.date = {
          day: dateValue.getUTCDate(),
          month: dateValue.getUTCMonth() + 1,
          year: dateValue.getUTCFullYear()
        };
        
        this.time = {
          hour: dateValue.getUTCHours(),
          minute: dateValue.getUTCMinutes(),
          second: dateValue.getUTCSeconds()
        };
        
      }
    } else {
      // 处理空值情况
      this.date = { year: 0, month: 0, day: 0 };
      this.time = { hour: 0, minute: 0, second: 0 };
    }
  }

  updateDateTimePicker() {
    if (!this.time || !this.date) {
      !this.date && !this.time && this.formCtrl.setValue(null);
      return;
    }
    
    const currentDateTime = Date.UTC(
      this.date?.year, 
      this.date?.month - 1, 
      this.date?.day, 
      this.time?.hour, 
      this.time?.minute, 
      this.time?.second
    );
    
    this.formCtrl.setValue(new Date(currentDateTime).toISOString());
  }
}